/* common */
export const REACT_APP_PAYLOAD_ENC_KEY = 'MgBGpNn9INxzEKiukiUPSnLJPnFZn4eWH8jux2dHUN4='

export const REACT_APP_PAYLOAD_ENC_IV = 'XQIorrZhL0pshe9DFCywdw=='

export const PY_SECRET_KEY = "yvwEPaue8AcuPkKbdA7nfRzW+nIRJvkwztvKw8zdUaU="

/* demo */

export const REACT_APP_TIME_URL = "https://quantaimobback.quantara.foundation/time_api";

export const REACT_APP_BACKEND_URL = "https://quantaimobback.quantara.foundation";

export const REACT_APP_CONSULTANT_SOCKET_URL = "";

export const REACT_APP_COMMON_SOCKET = "https://quantaimobback.quantara.foundation";

/* demo */

// export const REACT_APP_TIME_URL = 'https://quantramobile.osizdemos.com/time_api'

// export const REACT_APP_BACKEND_URL = "https://quantramobile.osizdemos.com";

// export const REACT_APP_COMMON_SOCKET = "https://quantramobile.osizdemos.com";

// export const REACT_APP_CONSULTANT_SOCKET_URL = "https://quantarasaasconsultadmpy.osizdemos.com";

/* local */

// export const REACT_APP_TIME_URL = 'http://172.16.16.191:4713/time_api'

// export const REACT_APP_BACKEND_URL = "http://172.16.16.191:4713";

// export const REACT_APP_CONSULTANT_SOCKET_URL = "http://172.16.16.191:6791";

// export const REACT_APP_COMMON_SOCKET = "http://172.16.16.191:4713";

/* viswa */

// export const REACT_APP_TIME_URL = 'http://172.16.16.166:4713/time_api'

// export const REACT_APP_BACKEND_URL = "http://172.16.16.166:4713";

// export const REACT_APP_COMMON_SOCKET = "http://172.16.16.166:4713";

// export const REACT_APP_CONSULTANT_SOCKET_URL = "http://172.16.16.166:4713";